export default __webpack_public_path__ + "static/media/to_right.3f8eee51.svg";